__turbopack_context__.v({
  "errorcontainer": "error-module__5GZeZW__errorcontainer",
  "errorimage": "error-module__5GZeZW__errorimage",
});
